export default "__VITE_ASSET__339885c7__"